var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-padding-l"},[_c('div',{staticClass:"h-bg-w h-padding-l"},[_c('MealEditor',{attrs:{"viewer":"page","recipe":_vm.recipe,"ingredients":_vm.ingredients},on:{"recipeSaved":_vm.recipeSaved,"scrollTop":_vm.scrollTop}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }